import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { FocusPayApplication } from "src/app/shared/models/FocusPay/FocusPayApplication.item";

@Component({
	selector: "app-application-status-single",
	templateUrl: "./application-status-single.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ApplicationStatusSingleComponent implements OnInit {
	@Input() applicationId: string;
	@Output() applicationIdEmitter = new EventEmitter<string>();

	application: FocusPayApplication;

	underwritingResult: {
		categoryLabel: string;
		results: {
			label: string;
			status: number;
			statusColor: string;
		}[];
	}[] = [];

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.getApplication();
	}

	applicationClose() {
		this.applicationIdEmitter.emit(undefined);
	}

	async getApplication() {
		const resp = await this.focuslink.focuspayApplicationGetOne(this.applicationId);
		this.application = new FocusPayApplication(resp);
		this.parseUnderwriting();
	}

	parseUnderwriting() {
		const categories = Array.from(new Set(this.application.partnerUnderwritingResults?.map((i) => i.CategoryLabel)));

		categories.forEach((category) => {
			this.underwritingResult.push({
				categoryLabel: category,
				results: this.application.partnerUnderwritingResults
					.filter((serviceResult) => serviceResult.CategoryLabel === category)
					.map((res) => {
						return {
							label: res.ServiceTitle,
							status: res.Status,
							statusColor: res.StatusLabel,
						};
					}),
			});
		});

		this.underwritingResult.forEach((category) => {
			switch (category.categoryLabel) {
				case "KYCBusiness":
					category.categoryLabel = "Merchant Business Information (KYCB)";
					break;
				case "KYCPersonal":
					category.categoryLabel = "Owner Personal Information (KYCP)";
					break;
				case "AcceptableUse":
					category.categoryLabel = "Merchant Business Operation (AcceptableUse)";
					break;
				case "Social":
					category.categoryLabel = "Social Media";
					break;
				default:
					break;
			}
		});
	}
}
